export default __webpack_public_path__ + "static/default-social-thumbnail-bc8820f96d83b17a473a387da7adba95.png";